const SvgNewest = (props) => (
  <svg height="1em" viewBox="0 0 17 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-1h18v18H0z" />
      <g stroke="currentColor">
        <path d="M1 12.552l2.5 2.5 2.5-2.5M3.5 14.5V0" />
      </g>
      <path
        d="M10.25 5.5H11V8L8.86 9.27l-.36-.605 1.75-1.04V5.5M10.5 3A4.5 4.5 0 0 1 15 7.5h1.5l-1.98 2.015L12.5 7.5H14a3.5 3.5 0 1 0-3.5 3.5c.965 0 1.84-.395 2.47-1.03l.71.71A4.448 4.448 0 0 1 10.5 12a4.5 4.5 0 0 1 0-9"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgNewest
